// T030: Updated with shared account flags and confirmation dialog
// Feature: 010-ios-android-zenky
// FIXED: Now using useDataProvider instead of direct fetch
import {
    BooleanInput,
    Edit,
    ListButton,
    required,
    SelectInput,
    ShowButton,
    SimpleForm,
    TextInput,
    TopToolbar,
} from 'react-admin';
import { validateUUID } from '../../utils/validation';
import { TemplateSelectInput } from './TemplateFields';

const EditActions = () => {
    return (
        <TopToolbar>
            <ListButton/>
            <ShowButton/>
        </TopToolbar>
    );
};


export const ClientEdit = () => (
    <Edit mutationMode="pessimistic" actions={<EditActions/>}>
        <SimpleForm>
            <TextInput source="id" disabled fullWidth/>
            <TextInput source="name" validate={required()} fullWidth/>
            <TextInput source="slug" disabled fullWidth helperText="Slug cannot be changed"/>
            <TextInput
                source="zenkyStoreId"
                label="Zenky Store ID"
                validate={validateUUID}
                helperText="UUID format (e.g., 550e8400-e29b-41d4-a716-446655440000)"
                fullWidth
                required
            />
            <SelectInput
                source="status"
                choices={[
                    { id: 'pending', name: 'Pending' },
                    { id: 'active', name: 'Active' },
                    { id: 'inactive', name: 'Inactive' },
                ]}
            />

            {/* Feature 012: switching the template takes effect from the next build */}
            <TemplateSelectInput/>

            {/* T030: Shared Account Settings section */}
            <BooleanInput source="useSharedIosAccount" label="Use Shared iOS Account"/>
            <BooleanInput source="useSharedAndroidAccount" label="Use Shared Android Account"/>
        </SimpleForm>
    </Edit>
);
